import { writable, get } from 'svelte/store';
import type { Screen } from '../types';

export const currentScreen = writable<Screen>('main');

export function showScreen(name: Screen) {
  if (get(currentScreen) === 'browser' && name !== 'browser') {
    (window as any).M1?.stopPreview?.();
  }
  currentScreen.set(name);
}
